/* eslint-disable import/no-extraneous-dependencies */
import { call, put, takeLatest } from 'redux-saga/effects';

import { axiosMicro } from '~/services';
import * as Actions from './actions';

function* getAllShippings({ payload = {} }) {
  try {
    const response = yield call(() => axiosMicro.get('/shippings', {
      params: payload,
    }));
    yield put(Actions.getAllShippingsSuccess(response.data));
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.getAllShippingsFailure(messages));
    }
  }
}

function* createShipping({ payload }) {
  try {
    const response = yield call(() => axiosMicro.post('/shippings', payload));
    yield put(Actions.createShippingSuccess(response.data));
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.createShippingFailure(messages));
    }
  }
}

function* updateShipping({ payload }) {
  try {
    const response = yield call(() => axiosMicro.patch(`/shippings/${payload.id}`, payload.body));
    yield put(Actions.updateShippingSuccess(response.data));
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.updateShippingFailure(messages));
    }
  }
}

function* deleteShipping({ payload }) {
  try {
    yield call(() => axiosMicro.delete(`/shippings/${payload}`));
    yield put(Actions.deleteShippingSuccess(payload));
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.deleteShippingFailure(messages));
    }
  }
}

// eslint-disable-next-line func-names
export default function* () {
  yield takeLatest(Actions.getAllShippingsRequest, getAllShippings);
  yield takeLatest(Actions.createShippingRequest, createShipping);
  yield takeLatest(Actions.updateShippingRequest, updateShipping);
  yield takeLatest(Actions.deleteShippingRequest, deleteShipping);
}
